export default "<slot name=\"styles\"></slot>\n<slot name=\"slides\"></slot>\n\n\n\n\n\n\n<style>\n</style>"